var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12893_383966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 8.48969C9.99992 9.59426 9.10449 10.4897 7.99992 10.4897C6.89535 10.4897 5.99992 9.59426 5.99992 8.48969C5.99992 7.38512 6.89535 6.48969 7.99992 6.48969C9.10449 6.48969 9.99992 7.38512 9.99992 8.48969Z",
    fill: "#C3CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.996675 8.07059C1.98336 5.10442 4.78111 2.96386 8.08076 2.96386C11.3789 2.96386 14.1756 5.10243 15.1635 8.06644C15.2589 8.35278 15.259 8.66253 15.1637 8.94892C14.177 11.9151 11.3793 14.0556 8.07964 14.0556C4.78152 14.0556 1.98484 11.9171 0.996935 8.95306C0.901501 8.66673 0.90141 8.35697 0.996675 8.07059ZM11.4999 8.48969C11.4999 10.4227 9.93292 11.9897 7.99992 11.9897C6.06692 11.9897 4.49992 10.4227 4.49992 8.48969C4.49992 6.55669 6.06692 4.98969 7.99992 4.98969C9.93291 4.98969 11.4999 6.55669 11.4999 8.48969Z",
    fill: "#C3CBD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12893_383966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0209961 0.489578) rotate(0.0746971)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e6ec8918b55f1d6f4a13a5b80887123d.svg";
export { ForwardRef as ReactComponent };